export default class Subcategory {
    constructor(id = '') {
        this.active = true;
        this.icon = "";
        this.iconURL = "";
        this.name = "";
        this.order = 0;
        this.isEmpty = false;
        this.localizedNames = [];
        this.id = id;
    }
}
